import React from 'react';
import {
  components as DefaultSelectComponents,
  ControlProps,
} from 'react-select';
import classNames from 'classnames';
import { InputSizes } from '@lib/components/Input/enums';
import styles from '../Select.module.scss';

function Control(props: ControlProps): React.ReactElement {
  const { children, ...restProps } = props;
  const { selectProps, isFocused } = restProps;
  // TODO: fix it (https://react-select.com/typescript#custom-select-props)
  const {
    menuIsOpen,
    // @ts-ignore
    label,
    isDisabled,
    isClearable,
    // @ts-ignore
    size,
    // @ts-ignore
    hasBorder,
    // @ts-ignore
    controlHasLeftPadding = true,
    // @ts-ignore
    rightAdornment,
    // rightAdornmentSlot: how many indicator slots are actually occupied
    // when rightAdornment is present — 1 (just the adornment), 2 (+ the
    // built-in dropdown/error indicator, shifted outward), or 3 (+ clear
    // too). Only sizes the reserved padding; rightAdornment itself always
    // renders at right:12px regardless (see IndicatorsContainer.tsx). The
    // caller picks this from its own known Select config, since it can't be
    // inferred here — react-select doesn't route a plain `style` prop
    // through this component's className-only styling.
    // @ts-ignore
    rightAdornmentSlot = 1,
  } = selectProps;
  const controlClassName = classNames(styles.control, {
    [styles.withoutBorder]: !hasBorder,
    [styles.controlClearable]: isClearable,
    [styles.controlLarge]: size === InputSizes.large,
    [styles.controlMedium]: size === InputSizes.medium,
    [styles.controlWithoutLeftPadding]: !controlHasLeftPadding,
    [styles.controlWithRightAdornmentSlot1]:
      rightAdornment && rightAdornmentSlot === 1,
    [styles.controlWithRightAdornmentSlot2]:
      rightAdornment && rightAdornmentSlot === 2,
    [styles.controlWithRightAdornmentSlot3]:
      rightAdornment && rightAdornmentSlot === 3,
    isFocused,
    isDisabled,
    menuIsOpen,
  });
  return (
    // @ts-ignore
    <DefaultSelectComponents.Control
      {...restProps}
      className={controlClassName}
    >
      {label && <span className={styles.selectLabel}>{label}</span>}
      {children}
    </DefaultSelectComponents.Control>
  );
}

export default Control;
